import { ColumnConfigurationRenderAs } from '@april9au/stack9-sdk';

import { ListTable } from '../../components/ListTable/ListTable';

type Props = {
  id: number;
};
const AccountUsers = ({ id }: Props) => (
  <ListTable
    queryVars={{ accountId: id }}
    queryName="getusersbyaccountlist"
    title="Users"
    columns={[
      {
        label: 'User name',
        field: 'username',
        renderAs: ColumnConfigurationRenderAs.Text,
        value: '{{username}}',
        options: {
          linkProp: '/crm/user/{{id}}',
        },
      },
      {
        label: 'First name',
        field: 'first_name',
        renderAs: ColumnConfigurationRenderAs.Text,
        value: '{{first_name}}',
      },
      {
        label: 'Last name',
        field: 'last_name',
        renderAs: ColumnConfigurationRenderAs.Text,
        value: '{{last_name}}',
      },
      {
        label: 'Email',
        field: 'email',
        renderAs: ColumnConfigurationRenderAs.Text,
        value: '{{email}}',
      },
      {
        label: 'Phone',
        field: 'phone',
        renderAs: ColumnConfigurationRenderAs.Text,
        value: '{{phone}}',
      },
      {
        label: 'Position',
        field: 'position',
        renderAs: ColumnConfigurationRenderAs.Text,
        value: '{{position}}',
      },
      {
        label: 'Default language',
        field: 'default_language',
        renderAs: ColumnConfigurationRenderAs.Text,
        value: '{{default_language}}',
      },
      {
        label: 'User groups',
        field: 'user_groups',
        value: '{{user_groups.map(item=>item.name)}}',
        renderAs: ColumnConfigurationRenderAs.EnumTags,
      },
      {
        label: 'Invited by',
        field: 'invited_by_user',
        renderAs: ColumnConfigurationRenderAs.Text,
        value: '{{invited_by_user.full_name}}',
      },
      {
        label: 'Created at',
        field: '_created_at',
        renderAs: ColumnConfigurationRenderAs.Date,
        value: '{{_created_at}}',
        options: {
          noTime: true,
        },
      },
    ]}
  />
);

export default AccountUsers;
